/*
 * The Job Agent's launch switch. Launched on the web on 2026-10-28: shown
 * everywhere — on the web free members see the teaser and paid members are
 * sent to the desktop app; in Desktop it runs. To hide it on the web again,
 * build with REACT_APP_JOB_AGENT_ON_WEB=false (Desktop builds that have the
 * bridge always show it).
 */
export const JOB_AGENT_ON_WEB = process.env.REACT_APP_JOB_AGENT_ON_WEB !== 'false';

export function jobAgentVisible(win = typeof window !== 'undefined' ? window : undefined, onWeb = JOB_AGENT_ON_WEB) {
  return onWeb || !!win?.jobAgent;
}
